import request from '../../axios';
import {LabSecondaryGetFormData} from '../../../utilities/helper/formDataConvertor';

const PutLabRedesignView = async (payload: IStoreLabRedesignView) => {
  const imagesPayload = {
    logo: payload.logo,
    lab_photo: payload.lab_photo,
    license: payload.license,
    national_card: payload.national_card,
  };

  const removeFields = (payload: IStoreLabRedesignView) => {
    delete payload.logo;
    delete payload.lab_photo;
    delete payload.license;
    delete payload.national_card;

    return payload;
  };
  const updatedPayload = removeFields(payload);
  await request.patch(
    `api/v2/store/lab-detail/${payload.guid}`,
    LabSecondaryGetFormData(
      imagesPayload as unknown as {[name: string]: string | Blob},
    ),
  );
  await request.patch(`api/v2/store/lab-detail/${payload.guid}`, {
    ...updatedPayload,
  });
};

export default PutLabRedesignView;
